export const constructSocialObject = (socialMedia: any) => {
  const socialData: any = {}

  const LINKEDIN = 'linkedin'
  const FACEBOOK = 'facebook'
  const TWITTER = 'twitter'
  const YOUTUBE = 'youtube'
  const INSTAGRAM = 'instagram'
  const WEIBO = 'weibo'
  const TOUTIAO = 'toutiao'
  const YOUKU = 'youku'
  const FOOTER_SOCIAL_INTRO = 'socials.footer.intro.text'
  const RIGHTS_RESERVED = 'rights.reserved.footer.text'
  const COOKIE_SETTING = 'cookie.setting.text'
  const ICP_NUMBER = 'icp.number.text'
  const SECURITY_NUMBER = 'security.number.text'
  const ICP_NUMBER_LINK = 'icp.number.link'
  const SECURITY_NUMBER_LINK = 'security.number.link'
  const COOKIE_SETTINGS_LINK = 'cookie-settings-link'
  const DISCLAIMER_FOOTER_TEXT = 'logo.disclaimer.footer.text'
  const socialMicrocopySet = socialMedia[0]?.values

  socialMicrocopySet?.forEach((social: any) => {
    if (social.key.startsWith(LINKEDIN)) socialData.LINKEDIN = social.value
    else if (social.key.startsWith(FACEBOOK)) socialData.FACEBOOK = social.value
    else if (social.key.startsWith(TWITTER)) socialData.TWITTER = social.value
    else if (social.key.startsWith(YOUTUBE)) socialData.YOUTUBE = social.value
    else if (social.key.startsWith(INSTAGRAM)) socialData.INSTAGRAM = social.value
    else if (social.key.startsWith(WEIBO)) socialData.WEIBO = social.value
    else if (social.key.startsWith(TOUTIAO)) socialData.TOUTIAO = social.value
    else if (social.key.startsWith(YOUKU)) socialData.YOUKU = social.value
    else if (social.key === FOOTER_SOCIAL_INTRO) socialData.FOOTER_SOCIAL_INTRO = social.value
    else if (social.key === RIGHTS_RESERVED) socialData.RIGHTS_RESERVED = social.value
    else if (social.key === COOKIE_SETTING) socialData.COOKIE_SETTING = social.value
    else if (social.key === ICP_NUMBER) socialData.ICP_NUMBER = social.value
    else if (social.key === SECURITY_NUMBER) socialData.SECURITY_NUMBER = social.value
    else if (social.key === ICP_NUMBER_LINK) socialData.ICP_NUMBER_LINK = social.value
    else if (social.key === SECURITY_NUMBER_LINK) socialData.SECURITY_NUMBER_LINK = social.value
    else if (social.key === COOKIE_SETTINGS_LINK) socialData.COOKIE_SETTINGS_LINK = social.value
    else if (social.key === DISCLAIMER_FOOTER_TEXT) socialData.DISCLAIMER_FOOTER_TEXT = social.value
  })

  return socialData
}

//* OneTrust Consent Manager
export const oneTrustCustomWinLoad = (callback: any) => {
  if (document.readyState === 'complete') {
    callback()
  } else {
    window.addEventListener('load', callback)
  }
}

export const loadOneTrust = (extraDelayMS: any) => {
  //* Initialization of OneTrust Consent Manager
  setTimeout(function () {
    var s = document.createElement('script')
    s.type = 'text/javascript'
    s.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
    s.async = true
    s.setAttribute('data-domain-script', '0614603d-bfe6-46ce-9263-9b2d0d1af676')
    s.setAttribute('nonce', '{{nonce}}')

    var i = document.getElementsByTagName('script')[0]
    i?.parentNode?.insertBefore(s, i)
    var s2 = document.createElement('script')
    s2.type = 'text/javascript'
    s2.setAttribute('nonce', '{{nonce}}')
    s2.innerHTML =
      "function OptanonWrapper() { window.dataLayer.push( { event: 'OneTrustGroupsUpdated'} );}"
    i?.parentNode?.insertBefore(s2, i)
  }, extraDelayMS)
}
